<template>

  <div>
    <div class="window-header">
      <h3 class="title">Retirar desde Cuenta Virtual</h3>
      <button
        class="button-close"
        @click="$modal.hide('virtualaccounts-debits')">×</button>
    </div>
    <div class="modal-content" v-if="!withthdrawalIsFinished">
      <p>
        Tu saldo actual:
        <b>{{ formatCurrency($store.getters.getUserBalance.balance) }}</b>
      </p>
      <form @submit.prevent="submit" novalidate>
        <fieldset>
          <div class="row row-responsive">
            <div class="column column-sm-50">
              <label for="withdrawalAmount">Monto a retirar:</label>
            </div>
            <div class="column column-sm-50">
              <money
                v-model.trim="$v.userInteraction.withdrawalAmount.$model"
                v-bind="money">
              </money>
              <p class="error" v-if="errors">
                <span v-if="!$v.userInteraction.withdrawalAmount.required">
                  El monto es obligatorio
                </span>
                <span v-if="!$v.userInteraction.withdrawalAmount.correctFunds">
                  El monto debe de ser mayor a $0 y menor o igual a tu saldo actual
                </span>
              </p>
            </div>
          </div>
          <div class="row row-responsive">
            <div class="column column-sm-50">
              <label
                for="selectedClabe">
                Selecciona a que clabe deseas retirar:
              </label>
            </div>
            <div class="column column-sm-50">
              <span class="select">
                  <select
                    v-model.trim="$v.userInteraction.selectedClabe.$model"
                    :class="{
                        'error-label': $v.userInteraction.selectedClabe.$error
                      }">
                    <option value="" disabled selected>Seleccione:</option>
                    <option
                      v-for="clabe in userClabes"
                      :key="clabe.clabe"
                      :value="clabe.id">
                      {{ clabe.bank_name }} - {{ clabe.clabe }}
                    </option>
                  </select>
                  <span class="arrow"></span>
                </span>
                <p class="error" v-if="errors">
                  <span
                    v-if="!$v.userInteraction.selectedClabe.required">
                    La selección de cuenta es obligatoria
                  </span>
                </p>
            </div>
          </div>
          <div class="modal-investment-buttons" v-if="!mfaIsVisible">
            <button
              class="button"
              @click.prevent="submit()">Confirmar retiro
            </button>
            <button class="button button-outline" @click="$modal.hide('virtualaccounts-debits')">Cancelar</button>
          </div>
        </fieldset>
      </form>
      <MFAHandler v-if="mfaIsVisible" v-on:tokenObtained="onClickedChild"></MFAHandler>
    </div>
    <div class="modal-content" v-if="withthdrawalIsFinished">
      <div class="column column-xs-100 column-sm-80 column-offset-sm-10">
          <div class="box-fields row row-responsive -vertical-align">
            <div class="column column-sm-20">
              <CheckmarkOK></CheckmarkOK>
            </div>
            <div class="column column-sm-80 -centered-info">
              <h3 class="title-final">Tu retiro desde tu Cuenta Virtual fue recibido con éxito.</h3>
              <button class="button" @click="$modal.hide('virtualaccounts-debits')">Cerrar</button>
            </div>
          </div>
        </div>
    </div>
  </div>

</template>

<script>

import CheckmarkOK from '@/components/CheckmarkOK'
import WaitingButton from '@/components/WaitingButton'
import MFAHandler from '@/components/MFAHandler'

import Vue from 'vue'
import money from 'v-money'

import { required } from 'vuelidate/lib/validators'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

Vue.use(money)

export default {
  name: 'DashboardVirtualAccountsModalDebit',
  data () {
    return {
      updateWithdrawal: false,
      errors: false,
      empty: false,
      mfaIsVisible: false,
      userInteraction: {
        withdrawalAmount: '',
        selectedClabe: ''
      },
      userClabes: [],
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2,
        masked: false
      },
      maxAmountDebit: false,
      amountDebitStatus: true,
      withthdrawalIsFinished: false,
      debitConfirmation: false,
      selectedBankAccount: ''
    }
  },
  validations: {
    userInteraction: {
      withdrawalAmount: {
        required,
        correctFunds (withdrawalAmount) {
          return (withdrawalAmount <= this.$store.getters.getUserBalance.balance &&
            withdrawalAmount > 0)
        }
      },
      selectedClabe: { required }
    }
  },
  mixins: [mixins, httpRequestMixin],
  components: {
    CheckmarkOK,
    WaitingButton,
    MFAHandler
  },
  methods: {
    getUserClabes: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investors/clabes/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          is_valid: true
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.userClabes = response.data.results
      }
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.mfaIsVisible = true
      }
    },
    onClickedChild: async function (token) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/withdraw/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          amount: this.userInteraction.withdrawalAmount,
          clabe: this.userInteraction.selectedClabe,
          token: token
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 201) {
        this.mfaIsVisible = false
        this.withthdrawalIsFinished = true
        this.refreshTable()
      } else {
        this.modalError(response.data, 'warning')
      }
    },
    refreshTable: function () {
      this.rerefresh = true
      return this.$emit('updateTableWithdrawal', this.updateWithdrawal)
    }
  },
  created: function () {
    this.getUserClabes()
  }
}

</script>

<style lang="scss" scoped>

.message {
  padding: .3rem .4rem;
  background-color: $red;
  color: #fff;
  font-size: .75em;
  border-radius: 3px;
}

.v-money ~ .message {
  margin-top: -1rem;
}

.label {
  font-weight: bold;
}

.error {
  color: $red;
}

.title-final {
  margin-bottom: .5rem;
  padding-bottom: .5rem;
  font-weight: 300;
  font-size: 1.1em;
}

</style>



// WEBPACK FOOTER //
// src/views/dashboardVirtualAccount/DashboardVirtualAccountsModalDebit.vue